import React, { PureComponent } from 'react';
import { Helmet as ReactHelmet } from 'react-helmet';

import { COOKIEBOT_CONSENT_TYPES } from 'Util/Browser';

import { WP_PIXEL_ID } from './WPEvents.config';
/** @namespace Pwa/Component/WPEvents/Component */
export class WPEvents extends PureComponent {
    renderBaseScriptContent() {
        const baseScriptContent = `!function(d,m,e,v,n,t,s){d['WphTrackObject'] = n;
        d[n] = window[n] || function() {(d[n].queue=d[n].queue||[]).push(arguments)},
        d[n].l = 1 * new Date(), t=m.createElement(e), s=m.getElementsByTagName(e)[0],
        t.async=1;t.src=v;s.parentNode.insertBefore(t,s)}(window,document,'script','https://pixel.wp.pl/w/tr.js', 'wph');
        wph('init', '${WP_PIXEL_ID}');`;

        return baseScriptContent;
    }

    renderBaseScript() {
        const script = document.getElementById('wp_base_script');

        if (script) {
            script.remove();
        }

        return WP_PIXEL_ID ? (
            <ReactHelmet>
                <script
                    defer
                    type="text/javascript"
                    id="wp_base_script"
                    data-cookieconsent={COOKIEBOT_CONSENT_TYPES.MARKETING}
                >
                    {this.renderBaseScriptContent()}
                </script>
            </ReactHelmet>
        ) : null;
    }

    render() {
        return this.renderBaseScript();
    }
}

export default WPEvents;
